export abstract class Keys {
    static readonly ZONE_2_PART_BOAT: string = 'zone_2_part_boat';
    static readonly ZONE_2_PART_WATER: string = 'zone_2_part_water';
    static readonly ZONE_2_PART_CROKO: string = 'zone_2_part_croko';
    static readonly ZONE_2_PART_NET: string = 'zone_2_part_net';
    static readonly ZONE_2_PART_RUINS: string = 'zone_2_part_ruins';
    static readonly IMG_ARC: string = 'arc';
    static readonly BIG_CAT_MALE_V3: string = 'cat_big_m_v3';
    static readonly BIG_CAT_FEMALE_V3: string = 'cat_big_f_v3';
    static readonly BIG_CAT_MALE_V4: string = 'cat_big_m';
    static readonly BIG_CAT_FEMALE_V4: string = 'cat_big_f';
    static readonly HEROES_COMMENT_3: string = 'heros_comment_3';
    static readonly HEROES_COMMENT_2: string = 'heros_comment_2';
    static readonly HEROES_COMMENT: string = 'heros_comment';
    static readonly BM_COINY: string = 'Coiny';
    static readonly BM_N_GREEN: string = 'n_green';
    static readonly BM_N_YELLOW: string = 'n_yellow';
    static readonly BM_N_RED: string = 'n_red';
    static readonly IMG_SPARK1: string = 'spark1';
    static readonly IMG_SPARK2: string = 'spark2';
    static readonly IMG_SPARK3: string = 'spark3';
    static readonly IMG_SNOW: string = 'snow';
    static readonly UI_BG: string = 'ui_Bg';
    static readonly IMG_LUCK_EFFECT_CLOVER: string = 'luck_effect';
    static readonly IMG_GREEN_CONTOUR: string = 'contour_green';
    static readonly IMG_RED_CONTOUR: string = 'contour_red';
    static readonly IMG_BLOCK_CONTOUR: string = 'contour_block';
    static readonly IMG_BLOCK_CONTOUR_GREEN: string = 'contour_block_green';
    static readonly IMG_BLOCK_YELLOW: string = 'cont_bl_yel';
    static readonly IMG_BLOCK_RED: string = 'cont_bl_red';
    static readonly IMG_BLOCK_VIOLET: string = 'cont_bl_violet';
    static readonly IMG_HAMMER_RED: string = 'hammerRed';
    static readonly IMG_HAMMER_VIOLET: string = 'hammerViolet';
    static readonly IMG_POISON: string = 'pois';
    static readonly IMG_KOSCHEY: string = 'kosch';
    static readonly FERN_SMALL: string = 'fern-small';
    static readonly IMG_RESURRECT_EFFECT: string = 'resurrect';
    static readonly IMG_ARROW: string = 'purple_arrow';
    static readonly IMG_LEVELUP_ICON: string = 'levelup_icon';
    static readonly IMG_GIVE_UP_FLAG: string = 'give_up_flag';
    static readonly IMG_AFFECT_BACKGROUND: string = 'affect_background';
    static readonly IMG_LOSE_RIBBON: string = 'lose_ribbon';
    static readonly IMG_VICTORY_RIBBON: string = 'victory_ribbon';
    static readonly IMG_LOSE_SKULL: string = 'lose_skull';
    static readonly SKIP_MV: string = 'skip_mv';
    static readonly IMG_VICTORY_KNIGHT: string = 'victory_knight';
    static readonly IMG_GREEN_DOT: string = 'green_dot';
    static readonly IMG_YELLOW_DOT: string = 'yellow_dot';
    static readonly IMG_TICKET: string = 'ticket';
    static readonly IMG_WHITE_SWORD: string = 'white_sword';
    static readonly IMG_WHITE_HEART: string = 'white_heart';
    static readonly IMG_WHITE_SHIELD: string = 'white_shield';
    static readonly IMG_DIALOG_BUBBLE: string = 'dialog_bubble';
    static readonly IMG_TICKET_BIG: string = 'ticket_big';
    static readonly IMG_BATTLE_RESULT_HEARTH: string = 'battle_result_hearth';
    static readonly IMG_ANVIL: string = 'anvil';
    static readonly UI_WINDOW_X_CUTE: string = 'window_x_cute';
    static readonly UI_SCROLL: string = 'scroll';
    static readonly UI_CARD_ATTACK_ICON_GOLD: string = 'card_attack_icon_gold';
    static readonly UI_CARD_DEFENCE_ICON_GOLD: string = 'card_defence_icon_gold';
    static readonly UI_CARD_ATTACK_ICON_GREY: string = 'card_attack_icon_grey';
    static readonly UI_CARD_DEFENCE_ICON_GREY: string = 'card_defence_icon_grey';
    static readonly UI_MENU_BACK: string = 'menu_back';
    static readonly CLAN_SHIELD: string = 'shield';
    static readonly UI_PROFILE_TITLE_LIGHTER: string = 'profile_title_lighter';
    static readonly UI_PROFILE_NAME_CHANGE: string = 'profile_namechange';
    static readonly UI_PROFILE_EXIT: string = 'profile_exit';
    static readonly UI_PROFILE_BOOTS_ON: string = 'profile_boots_on';
    static readonly UI_PROFILE_BOOTS_OFF: string = 'profile_boots_off';
    static readonly UI_PROFILE_AUTOTRANSLATE: string = 'profile_autotranslate';
    static readonly UI_PROFILE_HELP: string = 'profile_help';
    static readonly UI_PROFILE_MAIL: string = 'profile_mail';
    static readonly UI_PROFILE_PASSWORD: string = 'profile_passchange';
    static readonly UI_PROFILE_GIFT: string = 'profile_gift';
    static readonly UI_PROFILE_GIFT_GEMS: string = 'profile_gift_gems';
    static readonly UI_PROFILE_BAN: string = 'profile_ban';
    static readonly UI_PROFILE_SOUND_ON: string = 'profile_sound_on';
    static readonly UI_PROFILE_SOUND_OFF: string = 'profile_sound_off';
    static readonly UI_PROFILE_SOCIAL: string = 'profile_social';
    static readonly UI_PROFILE_LANG: string = 'lang';
    static readonly UI_PROFILE_BLOCK: string = 'profile_block';
    static readonly UI_GENDER_CHANGE: string = 'gender_change';

    static readonly UI_PROFILE_FORCES_INFO_PANEL: string = 'forces-info-panel';
    static readonly UI_PROFILE_FORCES_INFO_PANEL_MIDDLE: string = 'forces-info-panel-middle';
    static readonly UI_PROFILE_FORCES_INFO_PANEL_EDGE: string = 'forces-info-panel-edge';
    static readonly UI_RED_LINER: string = 'red-liner';
    static readonly UI_GOLD_DOT: string = 'gold-dot';
    static readonly UI_PROFILE_FORCES_INFO_PANEL_BOTTOM: string = 'forces-info-panel-bottom';
    static readonly UI_PROFILE_CHAR_BOTTOM_STRIPE: string = 'char-bottom-stripe';
    static readonly UI_PROFILE_CHAR_BOTTOM_STRIPE_2: string = 'char-bottom-stripe-2';
    static readonly UI_PROFILE_CHAR_BOTTOM_STRIPE_GRAY: string = 'char-bottom-stripe-gray';
    static readonly UI_PROFILE_FORCES_INFO_POINTER: string = 'forces-info-pointer';
    static readonly UI_PROFILE_EVIL_SIGN: string = 'evil-sign';
    static readonly UI_PROFILE_GOOD_SIGN: string = 'good-sign';
    static readonly UI_BLESSING_SIGN: string = 'blessing';
    static readonly UI_PROFILE_EVIL_SIGN_BIG: string = 'evil-sign-big';
    static readonly UI_PROFILE_GOOD_SIGN_BIG: string = 'good-sign-big';
    static readonly UI_GLASS: string = 'ui-glass';
    static readonly UI_COPY: string = 'ui-copy';
    static readonly UI_SHARE: string = 'ui-share';
    static readonly UI_SHARE_OK: string = 'ui-share-ok';
    static readonly UI_SHARE_VK: string = 'ui-share-vk';
    static readonly UI_SHARE_FB: string = 'ui-share-fb';

    static readonly EMPTY: string = 'empty';

    static readonly DETAILS: string = 'ui_det';
    static readonly ICON_HEROES: string = 'icon-heroes';
    static readonly ICON_CARDS: string = 'icon-cards';
    static readonly CARD_ELEPHANT: string = 'card-elephant';
    static readonly CARD_ELEPHANT_SMALL: string = 'card-elephant-small';
    static readonly CARD_ARK: string = 'card-ark';
    static readonly CARD_ARK_SMALL: string = 'card-ark-small';
    static readonly CARD_SNAKE: string = 'card-snake';
    static readonly CARD_SNAKE_SMALL: string = 'card-snake-small';
    static readonly CARD_MOUSE: string = 'card-mouse';
    static readonly CARD_MOUSE_SMALL: string = 'card-mouse-small';
    static readonly CARD_EAGLE: string = 'card-eagle';
    static readonly CARD_EAGLE_SMALL: string = 'card-eagle-small';
    static readonly CARD_MITHRIL10K: string = 'card-mithril10k';
    static readonly CARD_MITHRIL10K_SMALL: string = 'card-mithril10k-small';
    static readonly CARD_EVOLUTION_DRYAD: string = 'card-dryad';
    static readonly CARD_EVOLUTION_UNIVERSAL: string = 'card-evolution';
    static readonly CARD_EVOLUTION_FACELESS: string = 'card-faceless';
    static readonly CARD_EVOLUTION_LUCK: string = 'card-fortune';
    static readonly CARD_EVOLUTION_GORGON: string = 'card-gorgon';
    static readonly CARD_EVOLUTION_BERSERK: string = 'card-berserk';
    static readonly CARD_EVOLUTION_SKULD: string = 'card-skuld';
    static readonly CARD_EVOLUTION_SIKJI: string = 'card-sikji';
    static readonly CARD_EVOLUTION_URD: string = 'card-urd';
    static readonly CARD_EVOLUTION_VERDANDI: string = 'card-verdandi';
    static readonly CARD_EVOLUTION_HIGHLANDER: string = 'card-highlander';
    static readonly CARD_EVOLUTION_INACCESSIBILITY: string = 'card-inaccessibility';
    static readonly CARD_EVOLUTION_INCUBUS: string = 'card-incubus';
    static readonly CARD_EVOLUTION_KOSCHEI: string = 'card-koschei';
    static readonly CARD_EVOLUTION_MANTICORE: string = 'card-manticore';
    static readonly CARD_EVOLUTION_NUN: string = 'card-nun';
    static readonly CARD_EVOLUTION_PHOENIX: string = 'card-phoenix';
    static readonly CARD_EVOLUTION_RIDER: string = 'card-rider';
    static readonly CARD_EVOLUTION_SHADOW: string = 'card-shadow';
    static readonly CARD_EVOLUTION_SPHINX: string = 'card-sphinx';
    static readonly CARD_EVOLUTION_SUCCUBUS: string = 'card-succubus';
    static readonly CARD_EVOLUTION_WITCH: string = 'card-witch';
    static readonly CARD_EVOLUTION_ACE: string = 'card-ace';
    static readonly CARD_EVOLUTION_CHAOS: string = 'card-chaos';
    static readonly CARD_EVOLUTION_DEATH: string = 'card-death';
    static readonly CARD_EVOLUTION_DRYAD_SMALL: string = 'card-dryad-small';
    static readonly CARD_EVOLUTION_UNIVERSAL_SMALL: string = 'card-evolution-small';
    static readonly CARD_EVOLUTION_FACELESS_SMALL: string = 'card-faceless-small';
    static readonly CARD_EVOLUTION_LUCK_SMALL: string = 'card-fortune-small';
    static readonly CARD_EVOLUTION_GORGON_SMALL: string = 'card-gorgon-small';
    static readonly CARD_EVOLUTION_BERSERK_SMALL: string = 'card-berserk-small';
    static readonly CARD_EVOLUTION_SKULD_SMALL: string = 'card-skuld-small';
    static readonly CARD_EVOLUTION_SIKJI_SMALL: string = 'card-sikji-small';
    static readonly CARD_EVOLUTION_URD_SMALL: string = 'card-urd-small';
    static readonly CARD_EVOLUTION_VERDANDI_SMALL: string = 'card-verdandi-small';
    static readonly CARD_EVOLUTION_HIGHLANDER_SMALL: string = 'card-highlander-small';
    static readonly CARD_EVOLUTION_INACCESSIBILITY_SMALL: string = 'card-inaccessibility-small';
    static readonly CARD_EVOLUTION_INCUBUS_SMALL: string = 'card-incubus-small';
    static readonly CARD_EVOLUTION_KOSCHEI_SMALL: string = 'card-koschei-small';
    static readonly CARD_EVOLUTION_MANTICORE_SMALL: string = 'card-manticore-small';
    static readonly CARD_EVOLUTION_NUN_SMALL: string = 'card-nun-small';
    static readonly CARD_EVOLUTION_PHOENIX_SMALL: string = 'card-phoenix-small';
    static readonly CARD_EVOLUTION_RIDER_SMALL: string = 'card-rider-small';
    static readonly CARD_EVOLUTION_SHADOW_SMALL: string = 'card-shadow-small';
    static readonly CARD_EVOLUTION_SPHINX_SMALL: string = 'card-sphinx-small';
    static readonly CARD_EVOLUTION_SUCCUBUS_SMALL: string = 'card-succubus-small';
    static readonly CARD_EVOLUTION_WITCH_SMALL: string = 'card-witch-small';
    static readonly CARD_EVOLUTION_ACE_SMALL: string = 'card-ace-small';
    static readonly CARD_EVOLUTION_CHAOS_SMALL: string = 'card-chaos-small';
    static readonly CARD_EVOLUTION_DEATH_SMALL: string = 'card-death-small';
    static readonly CARD_EVOLUTION_DRUID: string = 'card-druid';
    static readonly CARD_EVOLUTION_DRUID_SMALL: string = 'card-druid-small';

    static readonly TASK_BIRTHDAY_DRONT: string = 'task-birthday-dront';
    static readonly TASK_BIRTHDAY_QUEEN: string = 'task-birthday-queen';
    static readonly UI_PAYMENT_CHANGE: string = 'ui_wallet';
    static readonly UI_UI_CHANGE: string = 'ui_mode';
    static readonly UI_PUSH_CHANGE: string = 'push_mode';
    static readonly UI_QA_CHANGE: string = 'qa_mode';
    static readonly UI_BADGE_LINER: string = 'badge_liner';
    static readonly UI_DAMAGE_HEARTH: string = 'damage_hearth';
    static readonly UI_DAMAGE_SHIELD: string = 'damage_shield';
    static readonly UI_DAMAGE_SWORD: string = 'damage_sword';
    static readonly UI_EXIT_DOOR: string = 'exit_door';
    static readonly IMG_ATTACK: string = 'attack';
    static readonly IMG_DEFENCE: string = 'defence';
    static readonly IMG_HEART_ICON: string = 'heart_icon';
    static readonly UI_BUTTON_BROWN: string = 'brown_button';
    static readonly UI_BUTTON_BROWN_SMALL: string = 'brown_button_s';
    static readonly UI_BUTTON_BROWN_NEW: string = 'brown_button_new';
    static readonly UI_BUTTON_RED_NEW: string = 'red_button_new';
    static readonly UI_BUTTON_ADD_TO_SQUAD: string = 'button_add_to_squad';
    static readonly UI_SQUARE_FRAME: string = 'square_frame';
    static readonly UI_ARROW: string = 'arrow';
    static readonly UI_ARROW_LEFT: string = 'arr_left';
    static readonly UI_ARROW_RIGHT: string = 'arr_right';
    static readonly UI_ARROW_UP: string = 'arr_up';
    static readonly UI_ARROW_DOWN: string = 'arr_down';
    static readonly UI_HEALTH_BAR_INNER: string = 'health_bar_inner';
    static readonly UI_HEALTH_BAR_OUTER: string = 'health_bar_outer';
    static readonly UI_KOSCHEY_BAR_OUTER: string = 'koschey_bar_outer';
    static readonly UI_BLACK: string = 'black';
    static readonly UI_CONS_SLOT_BACKGROUND: string = 'cons_slot_background';
    static readonly UI_CONS_SLOT_BORDER: string = 'cons_slot_border';
    static readonly UI_CONS_PANEL_BACKGROUND: string = 'cons_panel_background';
    static readonly UI_CONS_EFFECT_ATTACK: string = 'cons_effect_attack';
    static readonly UI_CONS_EFFECT_DEFENCE: string = 'cons_effect_defence';
    static readonly UI_CONS_EFFECT_HEALTH: string = 'cons_effect_health';
    static readonly UI_ART_GIVE_UP_BUTTON: string = 'give_up_button';
    static readonly UI_WHITE_PLUS: string = 'white_plus';
    static readonly UI_WHITE_MINUS: string = 'white_minus';
    static readonly UI_GOLDEN_CHECK: string = 'golden_check';
    static readonly UI_NOTIF_PANEL: string = 'notif_panel';
    static readonly UI_LOCK: string = 'lock';
    static readonly UI_DECLINE_CROSS: string = 'decline_cross';
    static readonly UI_MAILIK: string = 'mailik';
    static readonly UI_SCENARIO_RIBBON: string = 'scenario_ribbon';
    static readonly UI_DAILY_RIBBON: string = 'daily_ribbon';
    static readonly UI_SCENARIO_TASK_BACK: string = 'scenario_task_back';
    static readonly UI_TASK_PROGRESS_BAR_INNER: string = 'task_bar_inner';
    static readonly UI_TASK_PROGRESS_BAR_OUTER: string = 'task_bar_outer';
    static readonly UI_TASK_TITLE_FLASH: string = 'title_flash';
    static readonly UI_STAT_MINE_OVAL: string = 'stat_mine_oval';
    static readonly UI_STAT_ENEMY_OVAL: string = 'stat_enemy_oval';
    static readonly UI_STAT_MINE_CIRCLE: string = 'stat_mine_circle';
    static readonly UI_STAT_WINDOW: string = 'stat_window2';
    static readonly UI_STAT_WINDOW_CORNER: string = 'stat_window_corner';
    static readonly UI_STAT_WINDOW_SEPARATOR: string = 'stat_window_separator';
    static readonly UI_STAT_WINDOW_BACK: string = 'stat_window_back';
    static readonly UI_BOX: string = 'box';
    static readonly UI_CHECK: string = 'check';
    static readonly UI_BORDER: string = 'border';
    static readonly HEALTH_TIMER_BACK: string = 'health_timer_back';
    static readonly GREEN_PLUS: string = 'green_plus';
    static readonly ARROW_CROSS: string = 'arrow_cross';
    static readonly UI_XSOLLA_LOGO: string = 'xsolla-logo';
    static readonly UI_ROBOKASSA_LOGO: string = 'robokassa-logo';

    static readonly NEW_GIFT: string = 'new_gift';

    static readonly UI2_ARENA: string = 'arena';
    static readonly UI2_ARENA_GR: string = 'arena_gr';
    static readonly UI2_BANK: string = 'bank';
    static readonly UI2_CHAT: string = 'chat';
    static readonly UI2_CLAN: string = 'clan';
    static readonly UI2_CLAN_GR: string = 'clan_gr';
    static readonly UI2_CRYSTAL: string = 'crystal';
    static readonly UI2_ELIXIR: string = 'elixir';
    static readonly UI2_GEM: string = 'gem';
    static readonly UI2_GOLD: string = 'gold';
    static readonly UI2_MAIL: string = 'mail';
    static readonly UI2_PLUS: string = 'plus';
    static readonly UI2_PROFILE: string = 'profile';
    static readonly UI2_RATING: string = 'rating';
    static readonly UI2_RES: string = 'res';
    static readonly UI2_SHOP: string = 'shop';
    static readonly UI2_FORUM: string = 'forum';
    static readonly UI2_EXP_BACK: string = 'exp_back';
    static readonly UI2_EXP_INNER: string = 'exp_inner';
    static readonly UI2_EXP_GLASS: string = 'exp_glass';
    static readonly UI2_TASKS: string = 'tasks';

    static readonly FRM_RADIO_OUT: string = 'radio_out';
    static readonly FRM_RADIO_IN: string = 'radio_in';
    static readonly FRM_UP: string = 'frm_up';
    static readonly FRM_UP_GREEN: string = 'frm_up_grn';
    static readonly FRM_TAG_BG: string = 'frm_tag_bg';
    static readonly FRM_CLOSE: string = 'frm_close';
    static readonly FRM_PIN_GREEN: string = 'frm_pin_green';
    static readonly FRM_PIN_ROUND: string = 'frm_pin_round';
    static readonly FRM_COPY_ROUND: string = 'frm_copy_round';
    static readonly FRM_PIN_WHITE: string = 'frm_pin_white';
    static readonly FRM_REPLY_ARROW: string = 'frm_reply_arrow';
    static readonly FRM_PAGING_BUTTON: string = 'frm_paging_button';
    static readonly FRM_PAGING_BUTTON2: string = 'frm_paging_button2';

    static readonly SOUND_GAIN_LOOT: string = 'gain_loot';
    static readonly SOUND_HORSE_WALK: string = 'horse_walk';
    static readonly SOUND_DEFEAT: string = 'sound_defeat';
    static readonly SOUND_VICTORY: string = 'sound_victory';
    static readonly SOUND_VICTORY_2: string = 'level_won';
    static readonly SOUND_PLACE_OPEN: string = 'sound_place_open';
    static readonly SOUND_WIND_UP: string = 'sound_wind_up';
    static readonly SOUND_WIND_DOWN: string = 'sound_wind_down';
    static readonly SOUND_ENEMY_PUNCH_1: string = 'enemy-punch-1';
    static readonly SOUND_ENEMY_PUNCH_2: string = 'enemy-punch-2';
    static readonly SOUND_ENEMY_PUNCH_3: string = 'enemy-punch-3';
    static readonly SOUND_PLAYER_PUNCH_1: string = 'player-punch-1';
    static readonly SOUND_PLAYER_PUNCH_2: string = 'player-punch-2';
    static readonly SOUND_PLAYER_PUNCH_3: string = 'player-punch-3';
    static readonly SOUND_AWARD: string = 'sound_award';
    static readonly SOUND_BUTTON_CLICK: string = 'sound_button_click';
    static readonly SOUND_CREATURE_CLICK: string = 'sound_creature_click';
    static readonly SOUND_BUILDING: string = 'sound_building';
    static readonly SOUND_SELECT: string = 'sound_select';
    static readonly SOUND_COMPLETED: string = 'completed';
    static readonly SOUND_LEVEL_UP: string = 'level-up';
    static readonly SOUND_USE_HEAL_POTION: string = 'use_heal_potion';
    static readonly SOUND_USE_SCROLL: string = 'use_scroll';
    static readonly SOUND_MOAN: string = 'moan';
    static readonly SOUND_RESURRECT: string = 'resur_sound';
    static readonly SOUND_HELP_MAN_RU: string = 'help_man_ru';
    static readonly SOUND_HELP_WOM_RU: string = 'help_wom_ru';
    static readonly SOUND_HELP_MAN_EN: string = 'help_man_en';
    static readonly SOUND_HELP_WOM_EN: string = 'help_wom_en';

    static readonly SOUND_NUN: string = 'sound_nun';
    static readonly SOUND_PING: string = 'sound_ping';
    static readonly SOUND_RIDER: string = 'sound_rider';

    static readonly MUSIC_ROAD: string = 'main-theme';
    static readonly MUSIC_MAGICAL: string = 'magical';
    static readonly MUSIC_MAGIC_FOREST: string = 'magic-forest';
    static readonly MUSIC_MAGICAL_FOREST: string = 'magical-forest';
    static readonly MUSIC_SERENITY_FOREST: string = 'serenity-forest';
    static readonly MUSIC_SUN_SPARKLING_FOREST: string = 'sun-sparkling-forest';
    static readonly MUSIC_CELTIC: string = 'celtic';

    static readonly MUSIC_CLAN: string = 'music_clan';

    static readonly MUSIC_FANTASY_SNEAK: string = 'fantasy-sneak';
    static readonly MUSIC_THE_MEDIEVAL: string = 'the_medieval';
    static readonly MUSIC_BATTLE: string = 'battle';
    static readonly MUSIC_BATTLE_2: string = 'battle_2';
    static readonly MUSIC_BATTLE_3: string = 'battle_3';
    static readonly MUSIC_BATTLE_4: string = 'military';

    public static readonly ANIM_KNIGHT_WALK_M: string = 'knight_walk_m';
    public static readonly ANIM_KNIGHT_IDLE_M: string = 'knight_idle_m';

    public static readonly ANIM_KNIGHT_WALK_W: string = 'knight_walk_w';
    public static readonly ANIM_KNIGHT_IDLE_W: string = 'knight_idle_w';

    static readonly IMG_RES_GEM_NO_SHADOW: string = 'res_gem_no_shadow';

    static readonly UI_FILTER_BTN_ACTIVE: string = 'filter_btn_active';
    static readonly UI_FILTER_BTN_INACTIVE: string = 'filter_btn_inactive';

    static readonly STAIRS_GREEN: string[] = ['green_1_100', 'green_101_200', 'green_201_300', 'green_301_400', 'green_401_500',
        'green_501_600', 'green_601_700', 'green_701_800', 'green_801_900', 'green_901_1000',
        'green_1001_1100', 'green_1101_1200', 'green_1201_1300', 'green_1301_1400', 'green_1401_1500',
        'green_1501_1600', 'green_1601_1700', 'green_1701_1800', 'green_1801_1900', 'green_1901_2000',
        'green_2001_2100', 'green_2101_2200', 'green_2201_2300', 'green_2301_2400', 'green_2401_2500',
        'green_2501_2600', 'green_2601_2700', 'green_2701_2800', 'green_2801_2900', 'green_2901_3000',
        'green_3001_3100', 'green_3101_3200', 'green_3201_3300', 'green_3301_3400', 'green_3401_3500',
        'green_3501_3600', 'green_3601_3700', 'green_3701_3800', 'green_3801_3900', 'green_3901_4000',
        'green_4001_4100', 'green_4101_4200', 'green_4201_4300', 'green_4301_4400', 'green_4401_4500',
        'green_4501_4600', 'green_4601_4700', 'green_4701_4800', 'green_4801_4900', 'green_4901_5000'];

    static readonly STAIRS_YELLOW: string[] = ['yellow_1_100', 'yellow_101_200', 'yellow_201_300', 'yellow_301_400', 'yellow_401_500',
        'yellow_501_600', 'yellow_601_700', 'yellow_701_800', 'yellow_801_900', 'yellow_901_1000',
        'yellow_1001_1100', 'yellow_1101_1200', 'yellow_1201_1300', 'yellow_1301_1400', 'yellow_1401_1500',
        'yellow_1501_1600', 'yellow_1601_1700', 'yellow_1701_1800', 'yellow_1801_1900', 'yellow_1901_2000',
        'yellow_2001_2100', 'yellow_2101_2200', 'yellow_2201_2300', 'yellow_2301_2400', 'yellow_2401_2500',
        'yellow_2501_2600', 'yellow_2601_2700', 'yellow_2701_2800', 'yellow_2801_2900', 'yellow_2901_3000',
        'yellow_3001_3100', 'yellow_3101_3200', 'yellow_3201_3300', 'yellow_3301_3400', 'yellow_3401_3500',
        'yellow_3501_3600', 'yellow_3601_3700', 'yellow_3701_3800', 'yellow_3801_3900', 'yellow_3901_4000',
        'yellow_4001_4100', 'yellow_4101_4200', 'yellow_4201_4300', 'yellow_4301_4400', 'yellow_4401_4500',
        'yellow_4501_4600', 'yellow_4601_4700', 'yellow_4701_4800', 'yellow_4801_4900', 'yellow_4901_5000'];

    static readonly STAIRS_RED: string[] = ['red_1_100', 'red_101_200', 'red_201_300', 'red_301_400', 'red_401_500',
        'red_501_600', 'red_601_700', 'red_701_800', 'red_801_900', 'red_901_1000',
        'red_1001_1100', 'red_1101_1200', 'red_1201_1300', 'red_1301_1400', 'red_1401_1500',
        'red_1501_1600', 'red_1601_1700', 'red_1701_1800', 'red_1801_1900', 'red_1901_2000',
        'red_2001_2100', 'red_2101_2200', 'red_2201_2300', 'red_2301_2400', 'red_2401_2500',
        'red_2501_2600', 'red_2601_2700', 'red_2701_2800', 'red_2801_2900', 'red_2901_3000',
        'red_3001_3100', 'red_3101_3200', 'red_3201_3300', 'red_3301_3400', 'red_3401_3500',
        'red_3501_3600', 'red_3601_3700', 'red_3701_3800', 'red_3801_3900', 'red_3901_4000',
        'red_4001_4100', 'red_4101_4200', 'red_4201_4300', 'red_4301_4400', 'red_4401_4500',
        'red_4501_4600', 'red_4601_4700', 'red_4701_4800', 'red_4801_4900', 'red_4901_5000'];

    static readonly BRIDGE: string = 'bridge';
    static readonly BRIDGE_2: string = 'bridge_2';
    static readonly GATE_1: string = 'gate_1';
    static readonly GATE_2: string = 'gate_2';
    static readonly ARCH_1: string = 'arch_1';
    static readonly ARCH_2: string = 'arch_2';
    static readonly TR_1: string = 'tr_1';
    static readonly TR_2: string = 'tr_2';
    static readonly TR_3: string = 'tr_3';
    static readonly TR_4: string = 'tr_4';
    static readonly TR_5: string = 'tr_5';

    static readonly PLACE_SHADOW: string = 'shadow';

    static readonly RAB_RU: string = 'rab_ru';
    static readonly RAB_EN: string = 'rab_en';

    static readonly TEXT_BACK: string = 'txt_back';

    static readonly PROFILE_BACK: string = 'profile_back';
    static readonly SHOP_BACK: string = 'shop_back';
    static readonly OBLIVION_BACK: string = 'oblivion-back';
    static readonly OBLIVION_BACK_2: string = 'obli-back-2';
    static readonly TASK_BACK: string = 'task_back';
    static readonly TASK_BOTTOM: string = 'task_bottom';
    static readonly SHOP_BOTTOM: string = 'shop_bottom';

    static readonly IMG_RES_GOLD: string = 'res_gold';
    static readonly IMG_RES_GOLD_NO_SHADOW: string = 'res_gold_no_shadow';
    static readonly IMG_RES_CRYSTAL: string = 'res_crystal';
    static readonly IMG_RES_ELIXIR: string = 'res_elixir';
    static readonly IMG_RES_ELIXIR_NO_SHADOW: string = 'res_elixir_no_shad';
    static readonly IMG_RES_SULFUR: string = 'res_sulfur';
    static readonly IMG_RES_CAVIAR: string = 'res_caviar';
    static readonly IMG_RES_HONEY: string = 'res_honey';
    static readonly IMG_RES_SULFUR_UI: string = 'res_sulfur_ui';
    static readonly IMG_RES_MITHRIL: string = 'res_mithril';
    static readonly IMG_CLICK_FLASH: string = 'click_flash';
    static readonly IMG_CROSSHAIR: string = 'crosshair';
    static readonly IMG_CROSS_SNOW: string = 'cross_snow';
    static readonly CLOUD: string = 'cldd';
    static readonly CLOUD2: string = 'cldd2';

    static readonly IMG_REWARD_CUPS: string = 'br_cups';
    static readonly IMG_REWARD_EXPERIENCE: string = 'br_experience';
    static readonly IMG_REWARD_CRYSTAL_YELLOW: string = 'br_crystal_yellow';
    static readonly IMG_REWARD_CRYSTAL_RED: string = 'br_crystal_red';
    static readonly IMG_REWARD_GOLD: string = 'br_gold';
    static readonly IMG_REWARD_GEM: string = 'br_gem';

    static readonly KM_HEAD: string = 'km_head';
    static readonly ARENA_HEAD: string = 'ar_head';
    static readonly ARENA_HEAD_IPHONE: string = 'ar_head_iphone';
    static readonly ARENA_BACK_MAIN: string = 'ar_back_main';
    static readonly ARENA_BACK_SECOND: string = 'ar_back_sec';
    static readonly ARENA_CUP: string = 'ar_cup';
    static readonly ARENA_HISTORY: string = 'ar_history';
    static readonly ARENA_REFRESH: string = 'ar_refresh';
    static readonly ARENA_TO_FIGHT: string = 'ar_fight';
    static readonly ARENA_HEART: string = 'ar_heart';
    static readonly ARENA_QUESTION: string = 'ar_question';
    static readonly DIVIDER_VERTICAL: string = 'divider-vert';
    static readonly IMG_BROOM_WITCH: string = 'broom_witch';
    static readonly IMG_FULT: string = 'fult';
    static readonly IMG_SNOWFLAKE_NG25: string = 'snowflake_ng25';
    static readonly IMG_TUZEMEC: string = 'tuzemec';

    static readonly ATLAS_NG_25: string = 'ng_25';


    static readonly ATLAS_LEAGUE_SMALL: string = 'atlas_league_small';
    static readonly ATLAS_LEAGUE: string = 'atlas_league';

    static readonly LEAGUE_1: string = 'league-icon-1';
    static readonly LEAGUE_2: string = 'league-icon-2';
    static readonly LEAGUE_3: string = 'league-icon-3';
    static readonly LEAGUE_4: string = 'league-icon-4';
    static readonly LEAGUE_5: string = 'league-icon-5';
    static readonly LEAGUE_6: string = 'league-icon-6';
    static readonly LEAGUE_7: string = 'league-icon-7';
    static readonly LEAGUE_8: string = 'league-icon-8';
    static readonly LEAGUE_9: string = 'league-icon-9';

    static readonly LEAGUE_SHADOW: string = 'league-icon-small-shadow';
    static readonly LEAGUE_1_SMALL: string = 'league-icon-small-1';
    static readonly LEAGUE_2_SMALL: string = 'league-icon-small-2';
    static readonly LEAGUE_3_SMALL: string = 'league-icon-small-3';
    static readonly LEAGUE_4_SMALL: string = 'league-icon-small-4';
    static readonly LEAGUE_5_SMALL: string = 'league-icon-small-5';
    static readonly LEAGUE_6_SMALL: string = 'league-icon-small-6';
    static readonly LEAGUE_7_SMALL: string = 'league-icon-small-7';
    static readonly LEAGUE_8_SMALL: string = 'league-icon-small-8';
    static readonly LEAGUE_9_SMALL: string = 'league-icon-small-9';

    static readonly IMG_PARTICLE_CIRCLE: string = 'circle';

    static readonly CHEST_GOLDEN_CLOSED: string = 'ch_gld_cls';
    static readonly CHEST_GOLDEN_OPENED: string = 'ch_gld_opn';
    static readonly CHEST_SILVER_CLOSED: string = 'ch_slv_cls';
    static readonly CHEST_SILVER_OPENED: string = 'ch_slv_opn';
    static readonly CHEST_AZURE_CLOSED: string = 'ch_azr_cls';
    static readonly CHEST_AZURE_OPENED: string = 'ch_azr_opn';
    static readonly CHEST_LAVA_CLOSED: string = 'ch_lv_cls';
    static readonly CHEST_LAVA_OPENED: string = 'ch_lv_opn';
    static readonly CHEST_AMBER_CLOSED: string = 'ch_amb_cls';
    static readonly CHEST_AMBER_OPENED: string = 'ch_amb_opn';
    static readonly CHEST_JADE_CLOSED: string = 'ch_jd_cls';
    static readonly CHEST_JADE_OPENED: string = 'ch_jd_opn';
    static readonly CHEST_GOLDEN_IC: string = 'ch_gld_ic';
    static readonly CHEST_SILVER_IC: string = 'ch_slv_ic';
    static readonly CHEST_AZURE_IC: string = 'ch_az_ic';
    static readonly CHEST_LAVA_IC: string = 'ch_lv_ic';
    static readonly CHEST_AMBER_IC: string = 'ch_amb_ic';
    static readonly CHEST_JADE_IC: string = 'ch_jd_ic';

    static readonly WHEEL: string = 'cmp_wheel';
    static readonly WHEEL_BACK_BTN: string = 'wheel_back_btn';
    static readonly WHEEL_CURSOR: string = 'wheel_cursor';
    static readonly WHEEL_CURSOR_2: string = 'wheel_cursor_2';
    static readonly WHEEL_DECOR: string = 'wheel_decor';
    static readonly WHEEL_ROLL_BTN: string = 'wheel_roll_btn';
    static readonly WHEEL_SPLASH: string = 'wheel_splash';
    static readonly WHEEL_SPLASH_2: string = 'wheel_splash_2';
    static readonly WHEEL_WING: string = 'wheel_wing';
    static readonly WHEEL_PROGRESS: string = 'wheel_progress';
    static readonly TO_WHEEL_BTN: string = 'to_wheel_btn';
    static readonly WHEEL_SMALL: string = 'wheel_small';
    static readonly WHEEL_BG_BOTTOM: string = 'wheel_bg_bottom';
    static readonly HEALTH_TO_ALL: string = 'health_to_all';
    static readonly HEALTH_TO_ONE: string = 'health_to_one';
    static readonly ATTACK_TO_ALL: string = 'attack_to_all';
    static readonly DEFENCE_TO_ALL: string = 'defence_to_all';

    static readonly IC_100_ATTACK: string = 'ic_attack';
    static readonly IC_100_DEFENCE: string = 'ic_defence';
    static readonly IC_100_HEALTH: string = 'ic_heart';
    static readonly IC_100_GOLD: string = 'ic_gold';
    static readonly IC_100_ELIXIR: string = 'ic_elixir';
    static readonly IC_100_CRYSTAL: string = 'ic_crystal';
    static readonly IC_100_MITHRIL: string = 'ic_mithril';
    static readonly IC_100_CAVIAR: string = 'ic_caviar';
    static readonly IC_100_HONEY: string = 'ic_honey';
    static readonly IC_100_ST_VIOLET: string = 'ic_st_vio';
    static readonly IC_110_MITHRIL: string = 'ic_mith_110';
    static readonly IC_100_AMETIST: string = 'ic_ametist';
    static readonly IC_100_SULFUR: string = 'ic_sulfur';
    static readonly IC_100_EXP: string = 'ic_exp';
    static readonly IC_100_KEY1: string = 'key1';
    static readonly IC_BRIGHT_CRYSTAL: string = 'ic_bright_crystal';
    static readonly IC_STATUE_1_TRIBUTE: string = 'ic_statue_1_tribute';
    static readonly IC_STATUE_2_TRIBUTE: string = 'ic_statue_2_tribute';
    static readonly IC_STATUE_3_TRIBUTE: string = 'ic_statue_3_tribute';
    static readonly IC_STATUE_4_TRIBUTE: string = 'ic_statue_4_tribute';
    static readonly IC_STATUE_5_TRIBUTE: string = 'ic_statue_5_tribute';
    static readonly IC_STATUE_6_TRIBUTE: string = 'ic_statue_6_tribute';
    static readonly IC_FLOWERS_1: string = 'ic_flowers_1';
    static readonly IC_MANDRAHORA: string = 'ic_mandrahora';
    static readonly IC_MUSHROOM_1: string = 'ic_mushroom_1';
    static readonly IC_LOUPE: string = 'loupe';
    static readonly IC_DRAGON_EGG: string = 'dragon_egg';
    static readonly IC_ELF_TRANDUIL: string = 'elf_tranduil';
    static readonly IC_PORTAL: string = 'portal';
    static readonly IC_RUNECRYSTAL_1: string = 'runecrystal_1';
    static readonly IC_RUNECRYSTAL_META: string = 'runecrystal_meta';
    static readonly IC_NECKLACE_1: string = 'necklace_1';
    static readonly IC_MEAT_PIE: string = 'meat-pie';
    static readonly IC_FRESH_MEAT_1: string = 'fresh-meat-1';
    static readonly IC_BERNIS_NO_SHADE: string = 'aunt-bernis-no-shade';
    static readonly IC_BILLY_NO_SHADE: string = 'billy-no-shade';
    static readonly IC_GLOOMBLOOM: string = 'ic_gloombloom';
    static readonly IC_DOOMBLOOM: string = 'ic_doombloom';
    static readonly IC_BALTUS_NO_SHADE: string = 'baltus-no-shade';
    static readonly IC_MINOTAUR: string = 'ic_minotaur';
    static readonly IC_BR_CUP: string = 'ic_br_cups';

    static readonly IMG_GREY_BACKGROUND: string = 'grey_background';
    static readonly IMG_SKULL_ICON: string = 'skull_icon';
    static readonly IMG_BATTLE_BACKGROUND: string = 'battle_background';
    static readonly IMG_ARENA_BACKGROUND: string = 'arena_background';
    static readonly IMG_PLAYER_TURN: string = 'your_turn';

    static readonly IMG_BLACK_BACKGROUND: string = 'black_background';

    static readonly IMG_LESSON_HAND: string = 'hand';
    static readonly IMG_LESSON_HAND_SHADOW: string = 'hand_shadow';

    static readonly IMG_CHAR_SELECTION_BACKGROUND: string = 'char_selection_back';
    static readonly IMG_CHAR_SELECTION_WINDOW: string = 'select_char_window';

    static readonly IMG_CARD_SHADE: string = 'card_shade';

    static readonly AGE_12: string = 'age_12';
    static readonly IMG_LOAD_SCREEN_BACKGROUND: string = 'load_screen_background';
    static readonly IMG_LOAD_SCREEN_TITLE_EN: string = 'load_title_en';
    static readonly IMG_LOAD_SCREEN_TITLE_RU: string = 'load_screen_title';
    static readonly IMG_LOAD_SCREEN_BAR_OUTER: string = 'load_screen_bar_outer';
    static readonly IMG_LOAD_SCREEN_BAR_INNER: string = 'load_screen_bar_inner';

    static readonly UI_MENU_ROAD: string = 'road-button';

    static readonly UI_LANG_BUTT: string = 'lang_butt';
    static readonly UI_LANG_ACC_BUTT: string = 'lang_acc_butt';

    static readonly UI_LANG_BUTT_AVAL: string = 'lang_butt_aval';
    static readonly UI_LANG_BUTT_UNAVAL: string = 'lang_butt_unaval';

    static readonly UI_LOGIN_BUTT: string = 'login_butt';
    static readonly UI_LOGIN_BUTT_BG: string = 'login_butt_bg';

    static readonly UI_ART_SLOT: string = 'slot';
    static readonly UI_ART_SLOT_DARK: string = 'slot-dark';
    static readonly UI_ART_SLOT_LOCKED: string = 'slot-locked';
    static readonly UI_ART_SLOT_UNLOCK: string = 'slot-unlock';

    static readonly UI_BOTTOM_MENU: string = 'bott_menu';

    static readonly UI_LEVEL_UP: string = 'levelUp';

    static readonly UI_ART_BASIC_WINDOW: string = 'art_window_basic';
    static readonly UI_ART_WINDOW_FORCES: string = 'art_window_forces';
    static readonly UI_WINDOW_HORIZONTAL: string = 'art_window_hor';
    static readonly UI_ART_X: string = 'x';
    static readonly UI_ART_CORNER_LEFT: string = 'corner-left';
    static readonly UI_ART_CORNER_DIAG: string = 'corner-diag';
    static readonly UI_ART_ARR: string = 'arr';
    static readonly UI_ART_TIME_ICON: string = 'timeIcon';
    static readonly UI_ART_LIGHT: string = 'light';
    static readonly P6_RU: string = 'p6ru';
    static readonly P7_RU: string = 'p7ru';
    static readonly P6_EN: string = 'p6en';
    static readonly P7_EN: string = 'p7en';
    static readonly UI_ART_GREEN_BUTTON: string = 'button-green';
    static readonly UI_ART_RED_BUTTON: string = 'button-red';
    static readonly UI_ART_PALE_BUTTON: string = 'button-pale';
    static readonly UI_ART_BROWN_BUTTON: string = 'button-brown';
    static readonly UI_ART_UPPER_ICON: string = 'upper';
    static readonly UI_ART_DECREASE_ICON: string = 'decrease';
    static readonly UI_ART_UPPER_ICON_GREEN: string = 'upper-green';
    static readonly UI_ART_TAKE_OFF: string = 'take-off';
    static readonly UI_ART_SLOT_LIGHT: string = 'slot-light';

    static readonly UI_WINDOW_MIDDLE: string = 'wind_mid';
    static readonly UI_WINDOW_MIDDLE_BIG: string = 'wind_mid_BIG';
    static readonly UI_WINDOW_BIG: string = 'wind_big';
    static readonly UI_WINDOW_BIG_2: string = 'wind_big_2';

    static readonly UI_CHECK_SIGN: string = 'check';
    static readonly UI_CROSS_SIGN: string = 'cross';
    static readonly UI_SQ_BUTTON: string = 'sq_button';

    static readonly UI_BACKPACK_ICON: string = 'backpack-icon';
    static readonly UI_MANUAL_ICON: string = 'manual-icon';
    static readonly UI_CRAFT_ICON: string = 'craft-icon';
    static readonly CRAFT_RESOURCE_ICONS: string[] = [
        'pi_2o_craft_leather',
        'pi_2o_craft_fur',
        'pi_2o_craft_fangs',
        'pi_2o_craft_orchid',
        'pi_2o_craft_hogweed',
        'pi_2o_craft_thorn',
        'pi_2o_craft_clothes_bad',
        'pi_2o_craft_clothes_good',
        'pi_2o_craft_bouquet_bad',
        'pi_2o_craft_bouquet_good',
        'pi_2o_craft_spear',
        'pi_2o_craft_gloves',
        'pi_2o_craft_notepad',
    ];
    static readonly UI_BACKPACK_WINDOW: string = 'backpack-window';
    static readonly UI_BACKPACK_INFO: string = 'backpack-info-panel';
    static readonly UI_BACKPACK_SLOTS_ICON: string = 'backpack-slots-icon';
    static readonly UI_BACKPACK_CORNER_SHADOW: string = 'backpack-corner-shadow';

    static readonly GREEN_TRIANGLE: string = 'gr_tri';

    static readonly UI_DISCOUNT_ENABLED: string = 'discount-enabled';
    static readonly UI_DISCOUNT_DISABLED: string = 'discount-disabled';

    static readonly UI_POWER_UP_BG_3: string = 'power-up-bg-3';
    static readonly UI_POWER_UP_ARROW: string = 'power-up-arrow';
    static readonly UI_POWER_UP_INFO_TOP: string = 'power-up-info-top';
    static readonly UI_POWER_UP_INFO_BOTTOM: string = 'power-up-info-bottom';
    static readonly UI_POWER_UP_INFO_MIDDLE: string = 'power-up-info-middle';

    static readonly UI_MANUAL_QUESTION_GREEN: string = 'manual-question-green';
    static readonly UI_MANUAL_BLUE_FADE: string = 'manual-blue-fade';
    static readonly UI_MANUAL_TOP_FRAME: string = 'manual-top-frame';

    static readonly UI_FORCES_BLACK_BG: string = 'force-black-bg';
    static readonly UI_FORCES_GLASS_BG: string = 'force-glass-bg';
    static readonly UI_FORCES_BLACK_ZONE: string = 'black-zone';
    static readonly UI_FORCES_BG_GOLD: string = 'bg-gold';
    static readonly UI_FORCES_INDICATOR_AVAILABLE: string = 'indicator-available';
    static readonly UI_FORCES_INDICATOR_UNAVAILABLE: string = 'indicator-unavailable';
    static readonly UI_FORCES_MAIN_HIGHLIGHT: string = 'force-main-highlight';
    static readonly UI_FORCES_HAMMER: string = 'hammer';
    static readonly UI_FORCES_HAMMER_G: string = 'hammer-g';
    static readonly UI_FORCES_HAMMER_BG: string = 'hummer-bg';
    static readonly UI_FORCES_HAMMER_PLUS: string = 'hummer-plus';
    static readonly UI_FORCES_INDICATOR_BG: string = 'indicator-bg';
    static readonly UI_FORCES_INDICATOR_CAN_UPGRADE: string = 'indicator-can-upgrade';
    static readonly UI_FORCES_INDICATOR_UPGRADE_IN_PROGRESS: string = 'indicator-upgrade-in-progress';
    static readonly UI_FORCES_TAB_ACTIVE: string = 'tab-active';
    static readonly UI_FORCES_TAB_INACTIVE: string = 'tab-inactive';

    static readonly GREEN_HORIZONTAL_BUTTON: string = 'gr_hor_butt';

    static readonly HOR_GREEN: string = 'hor_gr';
    static readonly HOR_BROWN: string = 'hor_br';

    static readonly EDU_BLACKOUT: string = 'edu_blackout';
    static readonly EDU_TEACHER: string = 'edu_girl';
    static readonly EDU_CAT: string = 'edu_cat';

    static readonly PACK_PANEL_BACK: string = 'pack-back';
    static readonly PACK_SILVER: string = 'gems-8';
    static readonly PACK_GOLDEN: string = 'gems-9';
    static readonly PACK_DOMINATOR: string = 'gems-10';
    static readonly PACK_GOD: string = 'gems-11';
    static readonly PACK_LIGHTING: string = 'pack-lighting';
    static readonly PACK_SEP: string = 'pack-sep';
    static readonly PACK_SEP_LONG: string = 'pack-sep-long';

    static readonly TOKEN: string = 'token';
    static readonly TOKEN_BIG: string = 'token_big';
    static readonly UI_SHOP_PANEL_BACK: string = 'shop-back';
    static readonly UI_SHOP_LIGHT: string = 'shop-light';
    static readonly UI_SHOP_SEPARATOR: string = 'shop-separator';
    static readonly UI_SHOP_SEPARATOR_LARGE: string = 'separator-large';
    static readonly UI_SHOP_X: string = 'shop-x';
    static readonly UI_SHOP_TAB_ACTIVE: string = 'shop-tab-active';
    static readonly UI_SHOP_TAB_INACTIVE: string = 'shop-tab-inactive';
    static readonly UI_SHOP_TITLE_LIGHT: string = 'shop-title-light';
    static readonly PLAY_REWARDED: string = 'play';
    static readonly UI_SHOP_GEMS_0: string = 'gems-0';
    static readonly UI_SHOP_GEMS_1: string = 'gems-1';
    static readonly UI_SHOP_GEMS_2: string = 'gems-2';
    static readonly UI_SHOP_GEMS_3: string = 'gems-3';
    static readonly UI_SHOP_GEMS_4: string = 'gems-4';
    static readonly UI_SHOP_GEMS_5: string = 'gems-5';
    static readonly UI_SHOP_GEMS_6: string = 'gems-6';
    static readonly UI_SHOP_GEMS_7: string = 'gems-7';
    static readonly UI_SHOP_ARTIFACT_EFFECT_DEFENCE_ICON: string = 'shop_item_effect_def';
    static readonly UI_SHOP_ARTIFACT_EFFECT_ATTACK_ICON: string = 'shop_item_effect_atk';
    static readonly UI_SHOP_ARTIFACT_EFFECT_HEALTH_ICON: string = 'shop_item_effect_hlth';
    static readonly UI_SHOP_PAGE_LOCK: string = 'shop_page_lock';

    static readonly UI_INFO: string = 'info';

    static readonly UI_WARNING: string = 'warning_icon';

    static readonly CLAN_RATING: string = 'clan_rating';
    static readonly CLAN_BUILDING: string = 'clan_building';
    static readonly CLAN_ONLINE: string = 'clan_online';
    static readonly CLAN_OFFLINE: string = 'clan_offline';
    static readonly CLAN_GEAR: string = 'clan_gear';
    static readonly CLAN_GEAR_2: string = 'clan_gear_2';
    static readonly CLAN_GEAR_3: string = 'clan_gear_3';
    static readonly CLAN_GEAR_4: string = 'clan_gear_4';

    static readonly CL_INVITE: string = 'cl_invite';
    static readonly CL_KICK: string = 'cl_kick';
    static readonly CL_UP: string = 'cl_up';
    static readonly CL_DOWN: string = 'cl_down';
    static readonly CL_FORUM: string = 'cl_forum';

    static readonly CL_ABOUT: string = 'cl_about';
    static readonly CL_BUDGET: string = 'cl_budget';
    static readonly CL_BUILD: string = 'cl_build';
    static readonly CL_CHAT: string = 'cl_chat';
    static readonly CL_FAME: string = 'cl_fame';
    static readonly CL_HEADER: string = 'cl_header';
    static readonly CL_MEMEBERS: string = 'cl_members';
    static readonly CL_ADVERTISEMENT: string = 'cl_advertisement';
    static readonly CL_OTHER: string = 'cl_other';
    static readonly CL_RAID: string = 'cl_raid';
    static readonly CL_RATING: string = 'cl_rating';
    static readonly CL_SHOP: string = 'cl_shop';
    static readonly CL_RECRUITING: string = 'cl_recruiting';

    static readonly CLAN_BACK: string = 'clan_back_';
    static readonly CLAN_THEME_BORDER: string = 'cl_th_bord';
    static readonly CLAN_THEME_PREFIX: string = 'cl_th_';

    static readonly CL_HAMMER: string = 'cl_ham';
    static readonly CL_ACADEMY: string = 'cl_academy';
    static readonly CL_GUILD: string = 'cl_guild';
    static readonly CL_LAB: string = 'cl_lab';
    static readonly CL_FACTORY: string = 'cl_factory';
    static readonly CL_HALL: string = 'cl_hall';
    static readonly CL_SNOWFLAKE: string = 'cl_snflk';

    static readonly CL_SMALL_RED_BUTTON: string = 'small-red-button';
    static readonly CL_BLACK_SQUARE: string = 'black-square';
    static readonly CL_GEAR_RESOURCE: string = 'clan-gear-resource';

    static readonly HINT_BUTTON: string = 'hint_button';
    static readonly FW_BUTTON: string = 'fw_button';

    static readonly OFFER_RIBBON: string = 'offer_ribbon';
    static readonly OFFER_RIBBON_EN: string = 'offer_ribbon_en';
    static readonly CAMPAIGN_RIBBON: string = 'ribbon_orange';
    static readonly OFFER_LIGHT_BACK: string = 'light_back';
    static readonly OFFER_SHOP_ICON: string = 'shop_icon';
    static readonly OFFER_RIBBON_FAT: string = 'ribbon_fat';
    static readonly CAMPAIGN_RIBBON_BLUE: string = 'ribbon_blue';
    static readonly RIBBON_FOR_BUNCH: string = 'ribbon_for_bunch';
    static readonly BATTLE_TOP_BOTTOM: string = 'batt_tp_bt';

    public static readonly MAIN_HERO_MAN_V3 = 'man-1';
    public static readonly MAIN_HERO_WOMAN_V3 = 'woman-1';

    public static readonly MAIN_HERO_MAN_V4 = 'man-1';
    public static readonly MAIN_HERO_WOMAN_V4 = 'woman-16';

    public static readonly MALE_CAT_V3: string = 'male-cat-2';
    public static readonly FEMALE_CAT_V3: string = 'female-cat-2';

    public static readonly MALE_CAT_V4: string = 'male-cat-3';
    public static readonly FEMALE_CAT_V4: string = 'female-cat-3';

    static readonly REPLICS: string[] = ['dark-mage-face', 'dark-gol', 'ice-gol', 'rock-gol'];

    static readonly ATLAS_PROFILE: string = 'atlas_prof';
    static readonly ATLAS_PRELOAD: string = 'atlas_prel';

    static readonly ATLAS_EFFECTS: string = 'atlas_eff';

    static readonly ATL_PACK_SKILLS: string = 'atl_p_skl';
    static readonly ATLAS_SKILLS: string = 'atlas_skills';
    static readonly SK_ATTACK: string = 'sk_attack';
    static readonly SK_DEFENCE: string = 'sk_defence';
    static readonly SK_HEALTH: string = 'sk_health';

    static readonly ATLAS_GIFTS: string = 'atlas_gifts';
    static readonly ATLAS_GIFTS_2: string = 'atlas_gifts_2';
    static readonly ATLAS_GIFTS_3: string = 'atlas_gifts_3';
    static readonly ATLAS_GIFTS_4: string = 'atlas_gifts_4';
    static readonly ATLAS_GIFTS_5: string = 'atlas_gifts_5';
    static readonly ATLAS_GIFTS_6: string = 'atlas_gifts_6';
    static readonly ATLAS_GIFTS_7: string = 'atlas_gifts_7';
    static readonly ATLAS_GIFTS_8: string = 'atlas_gifts_8';
    static readonly ATLAS_GIFTS_9: string = 'atlas_gifts_9';
    static readonly ATLAS_GIFTS_10: string = 'atlas_gifts_10';
    static readonly ATLAS_GIFTS_11: string = 'atlas_gifts_11';
    static readonly ATLAS_GIFTS_12: string = 'atlas_gifts_12';
    static readonly ATLAS_GIFTS_13: string = 'atlas_gifts_13';

    static readonly ATLAS_CHAIN: string = 'atlas_chain';
    static readonly CHAIN_DARK_BLACK: string = 'dark_black';
    static readonly CHAIN_DARK_GREY: string = 'dark_grey';
    static readonly CHAIN_LIGHT_GREEN: string = 'light_green';
    static readonly CHAIN_LIGHT_YELLOW: string = 'light_yellow';

    static readonly ATLAS_UI_FORCES: string = 'atlas_ui_forces';
    static readonly ATLAS_FORCES: string = 'atlas_forces';
    static readonly ATLAS_FORCES_6: string = 'atlas_forces_6';
    static readonly ATLAS_FORCES_7: string = 'atlas_forces_7';
    static readonly ATLAS_FORCES_BIG: string = 'atlas_forces_big';
    static readonly ATLAS_FORCES_BIG_6: string = 'atlas_forces_big_6';
    static readonly ATLAS_FORCES_BIG_7: string = 'atlas_forces_big_7';
    static readonly ATLAS_FORCES_LARGE: string = 'atlas_forces_large';
    static readonly ATLAS_FORCES_LARGE_2: string = 'atlas_forces_large_2';
    static readonly ATLAS_FORCES_LARGE_3: string = 'atlas_forces_large_3';
    static readonly ATLAS_FORCES_LARGE_6: string = 'atlas_forces_large_6';
    static readonly ATLAS_FORCES_LARGE_7: string = 'atlas_forces_large_7';
    static readonly ATLAS_FORCES_SEMI_LARGE: string = 'atlas_forces_semi_large';
    static readonly ATLAS_FORCES_SEMI_LARGE_6: string = 'atlas_f_s_l6';
    static readonly ATLAS_FORCES_SEMI_LARGE_7: string = 'atlas_f_s_l7';

    static readonly ATLAS_FORCES_2: string = 'atlas_forces_2';
    static readonly ATLAS_FORCES_BIG_2: string = 'atlas_forces_big_2';

    static readonly ATLAS_FORCES_5: string = 'atlas_forces_5';
    static readonly ATLAS_FORCES_BIG_5: string = 'atlas_forces_big_5';

    static readonly ATLAS_FORCES_MAGICAL_SHAMISEN_ORE_MINER: string = 'magical_shamisen_ore_miner';

    static readonly ATLAS_CREATURES_BATTLE_0: string = 'atlas_cr_battle_0';
    static readonly ATLAS_CREATURES_BATTLE_0_V5: string = 'atlas_cr_battle_0_v5';
    static readonly ATLAS_CREATURES_BATTLE_1: string = 'atlas_cr_battle_1';
    static readonly ATLAS_CREATURES_ROAD: string = 'atlas_cr_road';

    static readonly ATLAS_EDU: string = 'atlas_edu';
    static readonly ATLAS_EDU_2: string = 'atlas_edu_2';
    static readonly ATLAS_EDU_2_V4: string = 'atlas_edu_2_v4';
    static readonly ATLAS_EDU_3_V4: string = 'atlas_edu_3_v4';
    static readonly ATLAS_EDU_3: string = 'atlas_edu_3';
    static readonly ATLAS_EDU_6: string = 'atlas_edu_6';
    static readonly ATLAS_EDU_7: string = 'atlas_edu_7';
    static readonly ATLAS_EDU_8: string = 'atlas_edu_8';
    static readonly ATLAS_EDU_SDQ: string = 'atlas_edu_sdq';

    static readonly ATLAS_PLACES_1: string = 'atlas_places_1';
    static readonly ATLAS_SUPERSHOP: string = 'Supershop';
    static readonly ATLAS_IC_100: string = 'atlas_ic_100';
    static readonly ATLAS_BADGES: string = 'atlas_badge';
    static readonly ATLAS_BADGES_2: string = 'atlas_badge_2';
    static readonly ATLAS_POINTERS: string = 'atlas_pointers';
    static readonly ATLAS_CONSUMABLES_SHADE: string = 'atlas_cons_shade';
    static readonly ATLAS_CONSUMABLES_NO_SHADE: string = 'atlas_cons_no_shade';
    static readonly ATLAS_GAINABLE: string = 'atlas_gain';
    static readonly ATLAS_GAINABLE_2: string = 'atlas_gain_2';
    static readonly ATL_EVENT_GAINABLE: string = 'atlas_ev_gain';
    static readonly ATLAS_PLACES_BIRTHDAY: string = 'atlas_birthday';
    static readonly ATLAS_RUNES: string = 'runes';
    static readonly ATLAS_RUNES_4: string = 'runes4';
    static readonly ATLAS_UI: string = 'atlas_ui';
    static readonly ATLAS_GATHER: string = 'atlas_gather';

    static readonly ATLAS_UI_2: string = 'atlas_ui_2';

    static readonly ATLAS_PORTALS: string = 'atlas_portal';

    static readonly ATLAS_WO: string = 'wo';

    static readonly HINTER: string = 'hinter';

    static readonly PORTAL_P1: string = 'P1';
    static readonly PORTAL_P2: string = 'P2';
    static readonly PORTAL_P3: string = 'P3';
    static readonly PORTAL_P4: string = 'P4';
    static readonly PORTAL_P5: string = 'P5';
    static readonly PORTAL_P6: string = 'P6';
    static readonly PORTAL_P7: string = 'P7';
    static readonly PORTAL_P8: string = 'P8';
    static readonly PORTAL_P9: string = 'P9';
    static readonly PORTAL_P10: string = 'P10';
    static readonly PORTAL_PANEL_BACK: string = 'port_back';
    static readonly PORTAL_PANEL_LIGHT: string = 'port_light';


    static readonly ATLAS_POINTERS_ADD: string = 'atlas_pointers_add';
    static readonly ATLAS_POINTERS_ADD_2: string = 'atlas_pointers_add_2';

    static readonly ATLAS_P9_ROAD_OBJECTS: string = 'p9_road_objects';
    static readonly ATLAS_P9_DIALOG: string = 'p9_dialog';
    static readonly ATLAS_P9_DIALOG_V2: string = 'p9_dialog_v2';
    static readonly ATLAS_P9_SECRET_PORTAL: string = 'atlas_secret_portal';
    static readonly ATLAS_P9_MON_EXTRA: string = 'atlas_mon_extra';
    static readonly ATLAS_P10_HOME: string = 'p10_home';

    static readonly ATLAS_P10_ROAD_OBJECTS: string = 'p10_road_objects';
    static readonly ATLAS_P10_DIALOG: string = 'p10_dialog';
    static readonly ATLAS_PI_1O_PLACES: string = 'pi_1o_PLACES_road_7';
    static readonly ATLAS_FRACTION_POINTS_300: string = 'fraction_points_300';

    static readonly ROADS: string[] = ['road_forrest', 'road_fire', 'road_fire_2',
        'road_village', 'road_elves', 'road_winter', 'asg_straight', 'water_straight', 'water_strip', 'asg_strip', 'water_straight_2', 'water_strip_2',
        'fire_straight', 'water_elem_straight', 'earth_straight', 'air_straight', 'abyss_straight', 'abyss_side', 'abyss_dangeon', 'abyss_terminal',
        'miro_straight', 'miro_straight_2', 'miro_left', 'miro_right', 'abyss_left', 'exile_straight', 'miro_strip', 'miro_strip_2', 'ng25_moder_road',
        'alter_mirograd', 'forest_of_dreams', 'harpy_gorge', 'spider_lair',
        'road_of_soul', 'liar_of_werewolf', 'p9_earth_spirit', 'p9_symbol_air', 'p9_symbol_water', 'p9_symbol_fire',
        'p9_inside_mind', 'p9_road_to_monastery', 'p9_secret_portal', 'p9_secret_portal_strip', 'p9_road_to_monastery', 'p9_secret_way_to_monastery',
        'p9_siege_of_monastery', 'p9_monastery', 'p9_before_monastery_turn', 'ink_su', 'p10_instead_mirograd', 'p10_our_home', 'p10_son_trava', 'p10_oblivion',
        'p10_svetloyar', 'p10_chernomir', 'p10_hell', 'p10_house_left_up', 'p10_house_left_down', 'p10_house_right_up', 'p10_house_right_down', 'pi_1o_bad_guys_road',
        'arcadia_straight', 'arcadia_strip', 'pandora_straight', 'pandora_strip',
        'arcadia_straight_b', 'arcadia_strip_b', 'arcadia_loc_1', 'arcadia_loc_2', 'arcadia_loc_3', 'arcadia_loc_4', 'arcadia_loc_6'];

    static readonly ROADS_WEBP: string[] = ['atlant_straight', 'atlant_strip', 'dream_straight', 'dream_strip',
        'heaven_straight', 'heaven_strip', 'ghost_straight', 'ghost_strip', 'ny_straight', 'ny_strip',
        'p6_cave_straight', 'p6_cave_strip', 'p6_parallel_straight', 'p6_parallel_strip',
        'p7_cap_straight', 'p7_cap_strip', 'zone_forrest_straight', 'zone_forrest_strip'];

    static readonly ROADS_2: string[] = ['road_sand', 'sand_turn_left', 'sand_turn_right', 'desert_straight',
        'desert_strip', 'desert_turn', 'desert_turn_right', 'desert_oasis', 'desert_temple',
        'desert_ent', 'desert_elder', 'golden_straight', 'golden_turn'];

    static readonly ROADS_START = 'road_default';
    static readonly ROADS_START_2 = 'main_straight';

    static readonly ROADS_UI: string[] = ['road_default',
        'road_turn_right', 'road_turn_left', 'road_turn_left_fire', 'road_turn_right_vill',
        'road_turn_left_elves'];

    static readonly ZONES: string[] = ['phoenix_town', 'dragon_town', 'dragon_canyon', 'canyon', 'p1_key_cave', 'p1_portal', 'p1_elf', 'rock_golem_road', 'tree',
        'serra_cave', 'arch_world', 'canyon_abyss', 'loki_cave', 'marko_hut', 'pyramid_1', 'pyramid_2', 'pyramid_3', 'ruins_1',
        'A1_side_1', 'A1_side_2', 'A1_side_3', 'A1_side_4', 'A1_side_5', 'A1_side_6', 'A1_side_7', 'A1_side_8', 'A1_side_9',
        'A1_side_10', 'A1_side_11', 'A1_side_12', 'amazons_main', 'amazons_aband', 'sons_aband', 'A1_side_13', 'A1_side_14', 'A1_side_15',
        'A1_side_16', 'A1_side_17', 'A1_side_18', 'A1_side_19', 'A1_side_20', 'A1_side_21', 'A1_side_22', 'A1_side_23', 'A1_side_24',
        'dark_castle_real', 'dark_castle_enter', 'dark_castle_illusion', 'A1_portal',
        'symbol_1', 'symbol_2', 'symbol_3', 'symbol_4', 'symbol_5_a', 'symbol_5_b',
        'T1', 'T8', 'T12', 'house_11', 'house_11_b', 'house_12', 'D1', 'monk', 'house_witch',
        'S1', 'scene_27', 'B2_straight', 'B2_left', 'meet_point', 'meet_point_dark',
        'scene_33', 'scene_33_dark', 'cemetery', 'amazon_party', 'warehouse_1', 'warehouse_2', 'warehouse_5', 'warehouse_6', 'bath',
        'D1_side_1', 'D1_tent_1', 'D1_tent_2', 'D1_tent_3', 'D1_tent_4', 'D1_tent_4_night', 'D1_tent_5', 'D1_tent_6', 'D1_tent_7',
        'D1_tent_8', 'D1_tent_9', 'D1_tent_10', 'D1_tent_11', 'D1_writer_1', 'D1_writer_2', 'D1_house', 'D1_village',
        'D1_cave_1', 'D1_cave_2', 'A1_fire_sons', 'A1_fire_sons_tavern', 'A1_elder',
        'ash', 'castle', 'crystal_1', 'crystal_2', 'crystal_3', 'free_1', 'hydra', 'D1_dungeon',
        'lake_1', 'lake_2', 'lake_3', 'lake_4', 'lake_5', 'D1_pyr_1', 'D1_pyr_2', 'D1_pyr_3', 'D1_pyr_in_1', 'D1_pyr_in_2', 'D1_pyr_in_3', 'D1_pyr_in_4',
        'red', 'roots_1', 'roots_2', 'roots_3', 'scorp', 'D1_trees', 'walls', 'walls_2', 'walls_3', 'wasteland',
        'sym_1', 'sym_2', 'sym_light_1', 'sym_light_2', 'D1_ash_temple_out',
        'F1_ash_temple_in', 'F1_ash_temple_out', 'F1_bridge_1', 'F1_bridge_2', 'F1_bridge_3', 'F1_bridge_4', 'F1_cliff', 'F1_bridge_01',
        'F1_phoenix_temple_in', 'F1_phoenix_temple_in_2', 'F1_switch',
        'F1_titan_temple_in_1', 'F1_titan_temple_in_2', 'F1_titan_temple_in_3', 'F1_titan_temple_in_4', 'F1_crater', 'F1_fire',
        'F1_temple_out_1', 'F1_temple_out_2', 'F1_temple_out_3', 'F1_forrest', 'F1_mount', 'F1_stairs', 'F1_gates',
        'F1_underground_1', 'F1_win_square'];

    static readonly ZONES_W: string[] = ['arch_cave', 'arch_mountain', 'atlantis_twilight', 'atlant_t_strip', 'jungle', 'jungle_2',
        'loc_cave_11', 'loc_cave_12', 'loc_cave_13', 'loc_cave_14',
        'loc_cave_1', 'loc_cave_2', 'loc_cave_3', 'loc_cave_4', 'loc_cave_portal', 'ship', 'ship_eleph', 'ship_shadow', 'ship_top', 'village_1',
        '55K', '60K', '65K', '70K', '80K', 'pyr_1', 'pyr_2', 'p10_LOP_before_3_act', 'p10_LOP_paladin_sun', 'p10_LOT_assassin_shadow', 'p10_LOT_before_3_act', 'p10_road_1WOGD',
        'p10_road_2WOGD', 'p10_road_3WOGD', 'p10_road_5WOGD', 'p10_road_6WOGD', 'p10_road_cave_2_act', 'snow_cave_1', 'snow_cave_2',
        'totem_1', 'totem_2', 'totem_3', 'totem_4', 'totem_5',
        'loc4_1', 'loc4_2', 'loc4_3', 'loc4_4', 'loc4_5', 'loc4_6', 'loc4_7', 'loc4_8', 'loc4_9', 'loc4_10', 'loc4_8_in', 'loc4_9_in', 'loc4_10_in'];

    static readonly UNLOADABLE_LOC_IMAGES: string[] = ['buffalo', 'loc_cave_5', 'loc_cave_6', 'loc_cave_9', 'cheese', 'cave_hole',
        'loot_1', 'loot_2', 'loot_3', 'loot_4', 'loot_5', 'loot_6', 'loot_7', 'mod', 'muza', 'orange', 'serra', 'starship',
        'temple', 'temple_road', 'underground'];

    static readonly UNLOADABLE_LOC_ATLASES: string[] = ['ap_19', 'ap_20', 'ap_amuraya', 'ap_atl', 'ap_buffalo', 'ap_croco', 'ap_pets', 'ap_starship', 'ap_premium'];

    static readonly ROAD_MAIN: string[] = ['main_straight', 'main_strip',
        'main_right', 'main_left', 'main_fire', 'main_vill', 'main_elf'];

    static readonly ROAD_MAIN_JPG: string[] = ['A1_short', 'A1_long', 'A1_long_2', 'A1_long_3', 'A1_long_4',
        'A1_left', 'A1_right', 'A1_dense_forrest', 'V5_start_1', 'V5_start_2', 'V5_start_2_b', 'V5_start_3'];
    static readonly ROAD_DESERT_JPG: string[] = ['D1_long', 'D1_left', 'D1_right', 'D1_short', 'D1_tr_1', 'D1_tr_2', 'D1_scene_1'];
    static readonly ROAD_13_JPG: string[] = ['F1_left', 'F1_right', 'F1_long', 'F1_long_2', 'F1_long_3', 'F1_long_4', 'F1_long_5', 'F1_short', 'F1_turn'];

    static readonly ATL_CR_DB3: string = 'atl_cr_db3';
    static readonly ATL_PL_DB3: string = 'atl_pl_db3';
    static readonly ATL_EDU_DB3: string = 'atl_edu_db3';

    static readonly ATL_CR_DB4: string = 'atl_cr_db4';
    static readonly ATL_PL_DB4: string = 'atl_pl_db4';
    static readonly ATL_EDU_DB4: string = 'atl_edu_db4';

    static readonly ATLAS_PUMPKIN: string = 'atlas_pumpkin';
    static readonly ATLAS_ATL_AVA: string = 'atlas_atl_ava';
    static readonly ATLAS_CREATURES_BATTLE_2: string = 'atlas_cr_battle_2';
    static readonly ATLAS_CREATURES_BATTLE_2_V4: string = 'atlas_cr_battle_2_v4';
    static readonly ATLAS_CREATURES_BATTLE_3_V4: string = 'atlas_cr_battle_3_v4';
    static readonly ATLAS_CREATURES_BATTLE_4: string = 'atlas_cr_battle_4';
    static readonly ATLAS_CREATURES_BATTLE_5: string = 'atlas_cr_battle_5';
    static readonly ATLAS_CREATURES_BATTLE_8: string = 'atlas_cr_battle_8';
    static readonly ATLAS_CREATURES_BATTLE_9: string = 'atlas_cr_battle_9';
    static readonly ATLAS_CREATURES_BATTLE_10: string = 'atlas_cr_battle_10';
    static readonly ATLAS_CREATURES_BATTLE_11: string = 'atlas_cr_battle_11';
    static readonly ATLAS_CREATURES_BATTLE_SCEN_8: string = 'atlas_cr_battle_s8';
    static readonly ATLAS_CREATURES_BATTLE_SCEN_10: string = 'atlas_cr_battle_s10';
    static readonly ATLAS_HERO_8: string = 'atlas_hero_8';
    static readonly ATLAS_HERO_9: string = 'atlas_hero_9';
    static readonly ATLAS_HERO_OB: string = 'atlas_hero_ob';
    static readonly ATLAS_HERO_10: string = 'atlas_hero_10';
    static readonly ATLAS_OF: string = 'atlas_of';
    static readonly ATLAS_RANK: string = 'atlas_rank';
    static readonly ATLAS_CREATURES_BATTLE_7: string = 'atlas_cr_battle_7';
    static readonly ATLAS_BATTLE_CATS: string = 'atlas_cats_b';
    static readonly ATLAS_BATTLE_DOGS: string = 'atlas_dogs_b';
    static readonly ATLAS_BATTLE_AM: string = 'atlas_am';
    static readonly ATLAS_BATTLE_TREE: string = 'atlas_tree';
    static readonly ATLAS_BATTLE_WT: string = 'atlas_wt';
    static readonly ATLAS_ANGELS: string = 'atlas_angels';
    static readonly ATLAS_TRIPLE_BATTLES: string = 'atlas_triple_battles';
    static readonly ATLAS_SIDE_QUESTS: string = 'atlas_side_quests';
    static readonly ATLAS_ROAD_CATS: string = 'atlas_cats_r';
    static readonly ATLAS_CREATURES_ROAD_2: string = 'atlas_cr_road_2';
    static readonly ATLAS_CREATURES_ROAD_4: string = 'atlas_cr_road_4';
    static readonly ATLAS_CREATURES_ROAD_5: string = 'atlas_cr_road_5';
    static readonly ATLAS_CREATURES_ROAD_8: string = 'atlas_cr_road_8';
    static readonly ATLAS_CREATURES_ROAD_9: string = 'atlas_cr_road_9';
    static readonly ATLAS_CREATURES_ROAD_11: string = 'atlas_cr_road_11';
    static readonly ATLAS_PLACES_2: string = 'atlas_places_2';
    static readonly ATLAS_PLACES_3: string = 'atlas_places_3';
    static readonly ATLAS_PLACES_4: string = 'atlas_places_4';
    static readonly ATLAS_PLACES_5: string = 'atlas_places_5';
    static readonly ATLAS_PLACES_6: string = 'atlas_places_6';
    static readonly ATLAS_PLACES_7: string = 'atlas_places_7';
    static readonly ATLAS_PLACES_8: string = 'atlas_places_8';
    static readonly ATLAS_PLACES_9: string = 'atlas_places_9';
    static readonly ATLAS_PLACES_10: string = 'atlas_places_10';
    static readonly ATLAS_PLACES_11: string = 'atlas_places_11';
    static readonly ATLAS_PLACES_12: string = 'atlas_places_12';
    static readonly ATLAS_PLACES_13: string = 'atlas_places_13';
    static readonly ATLAS_PLACES_14: string = 'atlas_places_14';
    static readonly ATLAS_PLACES_15: string = 'atlas_places_15';
    static readonly ATLAS_PLACES_16: string = 'atlas_places_16';
    static readonly ATLAS_PLACES_17: string = 'atlas_places_17';
    static readonly ATLAS_PLACES_18: string = 'atlas_places_18';
    static readonly ATLAS_PLACES_NY: string = 'places_ny';
    static readonly ATLAS_PLACES_NY_2026: string = 'places_ny_2026';
    static readonly ATLAS_PLACES_ARCADIA: string = 'places_arcadia';
    static readonly ATLAS_PLACES_ZONES_1: string = 'atlas_zones_1';
    static readonly ATLAS_PLACES_ZONES_2: string = 'atlas_zones_2';
    static readonly ATLAS_PLACES_ZONES_3: string = 'atlas_zones_3';
    static readonly ATLAS_PLACES_ELDER: string = 'places_elder';
    static readonly ATLAS_PRIESTESS: string = 'atlas_priest';

    static readonly ATLAS_UI_ART: string = 'atl_ui_art';
    static readonly ATLAS_ZONE_DRUID: string = 'atlas_zones_zrd';
    static readonly ATLAS_PLACES_TRIPLE: string = 'atlas_places_triple';
    static readonly ATLAS_PLACES_WATER: string = 'places-nps';
    static readonly ATLAS_PLACES_SIDE_QUESTS: string = 'places-sdq';
    static readonly ATLAS_POINTERS_2: string = 'atlas_pointers_2';
    static readonly ATLAS_POINTERS_2_V4: string = 'pointer_2_v4';
    static readonly ATLAS_POINTERS_3: string = 'atlas_pointers_3';
    static readonly ATLAS_POINTERS_4: string = 'atlas_pointers_4';
    static readonly ATLAS_POINTERS_8: string = 'atlas_pointers_8';
    static readonly ATLAS_POINTERS_SIDE_QUESTS: string = 'atlas_pointers_sdq';
    static readonly ATLAS_CONSUMABLES_SHADE_2: string = 'atlas_cons_shade_2';
    static readonly ATLAS_CONSUMABLES_NO_SHADE_2: string = 'atlas_cons_no_shade_2';
    static readonly ATLAS_CONSUMABLES_SHADE_4: string = 'atlas_cons_shade_4';
    static readonly ATLAS_CONSUMABLES_NO_SHADE_4: string = 'atlas_cons_no_shade_4';
    static readonly ATLAS_CONSUMABLES_SHADE_4X: string = 'atlas_cons_shade_4x';
    static readonly ATLAS_CONSUMABLES_NO_SHADE_4X: string = 'atlas_cons_no_shade_4x';
    static readonly ATLAS_CONS_SHADE_6: string = 'atl_cns_shd_6';
    static readonly ATLAS_CONS_NO_SHADE_6: string = 'atl_cns_no_shd_6';
    static readonly ATLAS_CONS_SHADE_7: string = 'atl_cns_shd_7';
    static readonly ATLAS_CONS_NO_SHADE_7: string = 'atl_cns_no_shd_7';
    static readonly ATLAS_CONS_PI_1O_45X45: string = 'pi_1o_consumable_voodoo_dolls_45x45';
    static readonly ATLAS_CONS_PI_1O_95X95: string = 'pi_1o_consumable_voodoo_dolls_95x95';
    static readonly ATLAS_CONS_PI_3O_45X45: string = 'pi_3o_consumable_voodoo_dolls_45x45';
    static readonly ATLAS_CONS_PI_3O_95X95: string = 'pi_3o_consumable_voodoo_dolls_95x95';
    static readonly ATLAS_BOOST: string = 'atlas_boost';
    static readonly ATLAS_BANK: string = 'atlas_bank';
    static readonly ATLAS_BANK_2: string = 'atlas_bank_2';
    static readonly ATLAS_OBLIVION: string = 'atlas_oblivion';
    static readonly ATLAS_SHOP_UI: string = 'atlas_shop_ui';

    static readonly ATLAS_PREMIUM_FORCES: string = 'premium-forces';
    static readonly ATLAS_PREMIUM_RANKS: string = 'premium-ranks';

    static readonly ADD_MUSHROOM: string = 'add-mushroom';

    static readonly ENEMY_LEV_5: string = 'enemy_5';
    static readonly BIRTHDAY_HATS: string[] = ['hat-1', 'hat-3', 'hat-5', 'hat-6', 'hat-7', 'hat-8', 'hat-10', 'hat-2', 'hat-4', 'hat-9'];
    static readonly BIRDS_FOR_MUSHROOM: string[] = ['sdq-bird1', 'sdq-bird2', 'sdq-bird3'];
    static readonly FLOWERS_FOR_WREATH: string[] = ['sdq-flower1', 'sdq-flower3'];

    static readonly ATLAS_P9_BATTLE_CREATURES: string = 'atlas_p9_battle_creatures';
    static readonly ATLAS_P9_BATTLE_CREATURES_V2: string = 'atlas_p9_battle_creatures_v2';
    static readonly ATLAS_P9_POINTER: string = 'p9_pointer';
    static readonly ATL_PACK_SKILLS_BONUS_CLAN: string = 'clan_bonus';
    static readonly ATLAS_PI_1O_BATTLE_CREATURES: string = 'pi_1o_heroes_fight_art'
    static readonly ATLAS_PI_1O_OB_BATTLE_CREATURES: string = 'pi_1o_heroes_ob_fight_art'
    static readonly ATLAS_PI_3O_BATTLE_CREATURES: string = 'pi_3o_heroes_fight_art'
    static readonly ICON_BONUS_SUN = 'icon_bonus_sun';
    static readonly ICON_BONUS_MOON = 'icon_bonus_moon';
    static readonly ICON_BONUS_SHADOW = 'icon_bonus_shadow';
    static readonly ICON_BONUS_CHEST = 'icon_bonus_chest';

    // Make an atlas later:
    static readonly ADDITIONAL_GAINABLES: string[] = ['task-fern', 'task-books', 'task-apple', 'life_bush', 'mirmaid_tail', 'task-pumpkin',
        'sdq-bird1', 'sdq-bird2', 'sdq-bird3', 'sdq-black-stone', 'find_saint_rock_for_statue', 'sdq-flower1', 'sdq-flower3', 'sdq-stem-floral', 'chickens', 'invis', 'nps-scale',
        'collect_map_parts', 'find_cavirals', 'black_matter_1', 'black_matter_2', 'black_matter_3', 'black_matter_4', 'mandarin', 'snowflake_ng25', 'broom_witch',
        'but1', 'but2', 'but3', 'but4', 'but5', 'but6', 'but7', 'but8', 'horseshoe2', 'arr', 'val', 'dumbbell', 'fire_feather', 'venus_heart', 'dawn_pearl', 'cucu', 'hru', 'birth_cake',
        'hedge', 'jay', 'crown', 'obl_stones', 'coconut', 'fun_ball', 'pumpkin', 'cake_8', 'cake_9', 'fly_2',
        'candy_1', 'candy_2', 'candy_3', 'shake_chocolate', 'shake_mango', 'shake_watermelon', 'watermelon'];

    static readonly EVENT_GAINABLES: string[] = ['strawberry', 'snail', 'pineapple', 'kiwi', 'penguin'];

    static readonly ADDITIONAL_CREATURES: string[] = ['fish-hero', 'squirrel', 'battle-teapot-1', 'battle-teapot-2', 'battle-teapot-3', 'battle-card-1', 'battle-card-2', 'battle-card-3',
        'nps-barbarian-1', 'nps-barbarian-2', 'nps-barbarian-3', 'nps-fishman', 'kiki',
        'kupala-beast-1', 'kupala-beast-2', 'kupala-beast-3', 'defiler_red', 'defiler_blue', 'defiler_green',  'tree', 'luckydrag', 'kitty', 'dark_serra', 'taitus', 'cow_1', 'cow_2',
        'hed_hog', 'owl_1', 'owl_2', 'owl_3', 'hlw_1', 'hlw_2', 'hlw_3', 'elf_shal_1', 'elf_shal_2', 'elf_shal_3',
        'valkiriya', 'acolyte', 'p9no_funny_merc_fight', 'pumpkin_3', 'pi_1o_amazon_arto', 'pi_1o_amazon_sirenia', 'pi_1o_hobbit_ekla',
        'pi_2o_lambert_hero_in_team', 'pi_2o_sofi_hero_in_team', 'pi_2o_vashka_hero_in_team',
        'pi_2o_kris_hero_in_team', 'pi_2o_tahlia_hero_in_team',
        'pi_2o_sara_hero_in_team', 'pi_2o_klara_hero_in_team', 'pi_2o_morana_hero_in_team'
        // 'p9s_shadow_1', 'p9s_forrest_demon', 'valkiriya', 'acolyte',
        // 'p9s_shadow_3', 'p9s_shadow_4', 'p9s_harpy', 'p9s_spider', 'p9s_werewolf', 'p9s_soul',
        // 'p9s_forrest_spirit', 'p9s_dark_thor', 'p9s_gorgon_1', 'p9s_gorgon_2', 'p9s_light_shadow',
        // 'p9s_martyr_1', 'p9s_oblivion'
    ];

    static readonly PREMIUM_CREATURES: string[] = ['ob_balt', 'ob_nun', 'ob_skuld', 'ob_serra', 'ob_shadow', 'ob_sikji'];

    static readonly PREMIUM_RANKS: string[] = ['10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26',
        '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40'];

    // Make an atlas later:
    static readonly ADDITIONAL_PLACES: string[] = ['forge', 'spring_elf', 'witch_1', 'yarilo', 'barrels', 'kupala-bonfire', 'cat',
        'ev_caterpillar', 'ev_cat', 'wings', 'feather',
        'p5_cube', 'ev_vamp', 'feast1', 'feast2', 'feast3', 'ev_byaka', 'cat_hole', 'cat_male', 'cat_female', 'goblin1', 'farm', 'pic_golem_in_the_field',
        'brain', 'carrot', 'dragon_egg', 'hole', 'sun', 'fox_and_scroll', 'wise_man', 'portal', 'desert_drag', 'egg', 'exile_with_hut',
        'sinhor_valarius' , 'portal_fire_4', 'portal_water_4','portal_air_4', 'portal_earth_4', 'strange_sheets', 'ark', 'monastery', 'amulet', 'flag1', 'cave_17', 'cc7', 'cc9', 'cc10',
        'sikji_boss', 'dark_cent'];

    static readonly PROFILE_CREATURES: string[] = [Keys.MAIN_HERO_MAN_V4, Keys.MAIN_HERO_WOMAN_V4,
        Keys.MALE_CAT_V4, Keys.FEMALE_CAT_V4];

    static readonly LOADING_ANIM: string = 'loading_anim';
    static readonly ANIM_BIRD_FLIGHT: string = 'bird';
    static readonly ANIM_BLUE_BIRD_FLIGHT: string = 'bird_blue';
    static readonly ATLAS_UI_GROUP_ARTIFACT: string = 'atlas_ui_group_artifact';
    static readonly ICON_GROUP_UPGRADE: string = 'icon_group_upgrade';

    static readonly ANIMS: string[] = ['dark_golem', 'ice_golem', 'rock_golem', Keys.LOADING_ANIM, 'seth-ent', Keys.ANIM_BIRD_FLIGHT, Keys.ANIM_BLUE_BIRD_FLIGHT];

    static battleCreature(creatureId: string): string {
        return 'b_' + creatureId;
    }

    static profileCreature(creatureId: string): string {
        return 'p_' + creatureId;
    }

    static profileAvatar(creatureId: string): string {
        return 'pa_' + creatureId;
    }

    static readonly ATLAS_PROMPT: string = 'prompt';
    static readonly UI_PROMPT_TOP: string = 'top';
    static readonly UI_PROMPT_MIDDLE: string = 'middle';
    static readonly UI_PROMPT_BOTTOM: string = 'bottom';
    static readonly IC_ORE_GOLD: string = 'ore_gold';
    static readonly ATLAS_PI_TASK: string = 'pi_task';
    static readonly ATLAS_AMAZONS: string = 'amazons';
    static readonly ATLAS_AMAZONS_DIALOG: string = 'amazons_dialog';

    static readonly ROADS_WEBP_PI: string[] = ['pi_1o_bad_guys_factory', 'pi_1o_druid_altar',
        'pi_1o_golden_mine_1_lvl', 'pi_1o_golden_mine_2_lvl', 'pi_1o_hermit_pirate', 'pi_1o_hitmakers_team',
        'pi_1o_inquisition_town', 'pi_1o_it_road_tent_armory', 'pi_1o_it_road_tent_cannon_room', 'pi_1o_it_road_tent_dorian',
        'pi_1o_it_road_tent_head_of_inquisition', 'pi_1o_kinky_party', 'pi_1o_leviathan_grotto', 'pi_1o_lg_maurizio_place',
        'pi_1o_lg_tot_place', 'pi_1o_lighthouse_jack', 'pi_1o_lumberjack_camp', 'pi_1o_lumberjack_camp_chapel',
        'pi_1o_lumberjack_camp_kilian_house', 'pi_1o_lumberjack_camp_martin_house', 'pi_1o_lumberjack_camp_obi_house',
        'pi_1o_lumberjack_camp_olaf_house', 'pi_1o_lumberjack_camp_tavern', 'pi_1o_magevoodoo_town', 'pi_1o_mangrove_jungle',
        'pi_1o_mj_kindergarten_inside', 'pi_1o_mj_tomb_kasumi_clons', 'pi_1o_mj_tomb_nameless_druid', 'pi_1o_mj_tomb_with_book',
        'pi_1o_mt_road_house_of_the_blashyrkh', 'pi_1o_mt_road_house_of_the_mentor', 'pi_1o_mt_road_house_of_the_raven',
        'pi_1o_mt_road_house_of_the_reaper', 'pi_1o_pg_crypt_for_player_1', 'pi_1o_pg_crypt_for_player_2',
        'pi_1o_pg_crypt_for_player_3', 'pi_1o_pg_deep_grave_road', 'pi_1o_pirates_graveyard', 'pi_1o_sugar_plantation',
        'pi_1o_sugar_plantation_warehouse', 'pi_1o_townAntigua', 'pi_1o_townAntigua_governor_palace',
        'pi_1o_townAntigua_governor_palace_compass', 'pi_1o_townAntigua_governor_palace_town_burning',
        'pi_1o_townAntigua_home_frail', 'pi_1o_townAntigua_home_steven', 'pi_1o_townAntigua_my_room',
        'pi_1o_townAntigua_sc_default', 'pi_1o_townAntigua_sc_ghost_home', 'pi_1o_townAntigua_sc_magevoodoo_home',
        'pi_1o_townAntigua_sc_pirate', 'pi_1o_townAntigua_sc_ugabuga_home', 'pi_1o_townAntigua_strange_basement',
        'pi_1o_townAntigua_tavern', 'pi_1o_townAntigua_town_burning', 'pi_1o_way_to_druid_altar'];

    static readonly ROADS_JPG_PI_2O: string[] = [
        'pi_2o_Diahla_cot_cave_kurchacha', 'pi_2o_black_moon_knights_castle', 'pi_2o_black_moon_knights_castle_traitor',
        'pi_2o_cave_of_trials', 'pi_2o_cliff', 'pi_2o_corn_plantation', 'pi_2o_forgotten_road', 'pi_2o_harbor_town',
        'pi_2o_harbor_town_gatehouse', 'pi_2o_harbor_town_warehouse_1st_floor', 'pi_2o_harbor_town_warehouse_2st_floor',
        'pi_2o_hobbits_town', 'pi_2o_hobbits_town_aribachi_house', 'pi_2o_hobbits_town_karuzo_house',
        'pi_2o_hobbits_town_kilko_house', 'pi_2o_hobbits_town_peshle_house', 'pi_2o_hobbits_town_shlyaka_house',
        'pi_2o_hobbits_town_uf_house', 'pi_2o_ice_ship', 'pi_2o_lake', 'pi_2o_lake_fisherman_house',
        'pi_2o_madness_of_savior', 'pi_2o_ritual_place', 'pi_2o_scorched_jungle', 'pi_2o_secret_lair',
        'pi_2o_sh_house_1_with_sara', 'pi_2o_sh_house_2', 'pi_2o_sh_house_3', 'pi_2o_sh_house_4', 'pi_2o_sh_house_5',
        'pi_2o_silent_hill', 'pi_2o_too_altar_of_filth', 'pi_2o_too_house_lashanna', 'pi_2o_too_house_slania',
        'pi_2o_town_of_displaced', 'pi_2o_town_of_displaced_communism_house', 'pi_2o_town_of_displaced_kindergarten',
        'pi_2o_town_of_displaced_meeting_house', 'pi_2o_town_of_displaced_watercloset', 'pi_2o_town_of_outcasts',
        'pi_2o_town_ugabuga', 'pi_2o_town_ugabuga_brewer_house', 'pi_2o_town_ugabuga_chief_house',
        'pi_2o_town_ugabuga_rkacha_house', 'pi_2o_town_ugabuga_sheika_house', 'pi_2o_vulcan_castle', 'pi_2o_vulcan_castle_final',
        'pi_1o_townAntigua_gp_room_of_head_of_pirates'];

    static readonly ATLASES_PI: string[] = [
        'pi_1o_heroes_fight_art',
        'pi_1o_heroes_ob_fight_art',
        'pi_1o_PLACES_fight_1',
        'pi_1o_PLACES_fight_2',
        'pi_1o_PLACES_fight_3',
        'pi_1o_PLACES_fight_4',
        'pi_1o_PLACES_fight_5',
        'pi_1o_PLACES_fight_6',
        'pi_1o_PLACES_pi_1o_lumberjack_camp',
        'pi_1o_PLACES_pi_1o_lumberjack_camp_2',
        'pi_1o_PLACES_pi_1o_pirates_graveyard',
        'pi_1o_PLACES_pi_1o_sugar_plantation_warehouse',
        'pi_1o_PLACES_pi_1o_townAntigua_my_room',
        'pi_1o_PLACES_pi_1o_way_to_druid_altar',
        'pi_1o_PLACES_road_1',
        'pi_1o_PLACES_road_2',
        'pi_1o_PLACES_road_3',
        'pi_1o_PLACES_road_4',
        'pi_1o_PLACES_road_5',
        'pi_1o_PLACES_road_6',
        'pi_1o_PLACES_road_7',
        'pi_2o_QUESTS_PICS_atlas_1',
        'pi_2o_QUESTS_PICS_atlas_2',
        'pi_2o_QUESTS_PICS_atlas_3',
        'pi_2o_QUESTS_PICS_atlas_4',
        'pi_2o_QUESTS_PICS_atlas_5',
        'pi_2o_QUESTS_PICS_atlas_6',
        'pi_2o_QUESTS_PICS_atlas_7',
        'pi_2o_PLACES_atlas_1',
        'pi_2o_PLACES_atlas_2',
        'pi_2o_PLACES_atlas_3',
        'pi_2o_PLACES_atlas_4',
        'pi_2o_PLACES_atlas_5',
        'pi_2o_PLACES_atlas_6',
        'pi_2o_PLACES_atlas_7',
        'pi_2o_PLACES_atlas_8',
        'pi_2o_PLACES_atlas_9',
        'pi_2o_PLACES_atlas_10',
        'pi_2o_PLACES_atlas_fight_1',
        'pi_2o_PLACES_atlas_fight_2',
        'pi_2o_PLACES_atlas_fight_3',
        'pi_2o_PLACES_atlas_fight_4',
        'pi_2o_PLACES_atlas_fight_5',
        'pi_2o_PLACES_road_craft_hunt',
        'pi_2o_PLACES_road_craft_hunt_fight',
        'pi_3o_heroes_fight_art',
        'pi_2o_QUESTS_PICS_atlas_grampi_hunt',
        'pi_2o_QUESTS_PICS_atlas_my_team',
        'pi_3o_QUESTS_PICS_atlas_1',
        'pi_3o_QUESTS_PICS_atlas_2',
        'pi_3o_QUESTS_PICS_atlas_3',
        'pi_3o_QUESTS_PICS_atlas_4',
        'pi_3o_QUESTS_PICS_atlas_5',
        'pi_3o_QUESTS_PICS_atlas_6',
        'pi_3o_QUESTS_PICS_atlas_7',
        'pi_3o_QUESTS_PICS_atlas_8',
        'pi_3o_QUESTS_PICS_atlas_9',
        'pi_3o_QUESTS_PICS_atlas_hard_monsters'
    ];

    static readonly HERO_LOCK_OPEN: string = 'hero_lock_open';
    static readonly HERO_LOCK_CLOSED: string = 'hero_lock_closed';


    static readonly ROADS_JPG_PI_3O: string[] = [
        'pi_3o_basement_with_cells', 'pi_3o_c_sh_stone_mine', 'pi_3o_c_sten_house', 'pi_3o_cliff_path', 'pi_3o_coast',
        'pi_3o_coffee_plantation', 'pi_3o_ekg', 'pi_3o_ekg_tent_barraks', 'pi_3o_ekg_tent_king', 'pi_3o_ekg_tent_weapons',
        'pi_3o_intelligence_of_inquisition', 'pi_3o_ioi_byron_tent', 'pi_3o_ioi_sasha_tent', 'pi_3o_lawless_camp',
        'pi_3o_lawless_ship', 'pi_3o_lc_bonney_ann_tent', 'pi_3o_lc_pirate_tent', 'pi_3o_ls_captain_cabin', 'pi_3o_ls_hull',
        'pi_3o_ls_hull_sex', 'pi_3o_magevoodoo_stronghold_town', 'pi_3o_magevoodoo_women_town',
        'pi_3o_mstown_for_magik_home', 'pi_3o_mstown_kirana_home', 'pi_3o_mstown_lamar_home', 'pi_3o_mstown_shaman_home',
        'pi_3o_mwt_meditation_home', 'pi_3o_mwt_natali_home', 'pi_3o_mwt_sleep_home', 'pi_3o_mwt_vacation_home',
        'pi_3o_my_ship', 'pi_3o_my_ship_my_cabin_01', 'pi_3o_my_ship_my_cabin_02', 'pi_3o_my_ship_my_cabin_03',
        'pi_3o_my_ship_trophy_cabin', 'pi_3o_path_of_initiation', 'pi_3o_pc_tent_silent_fresh', 'pi_3o_pc_tent_sonya',
        'pi_3o_pier_town', 'pi_3o_pier_town_barracks', 'pi_3o_pier_town_tavern', 'pi_3o_pier_town_training_room',
        'pi_3o_pier_town_treasury', 'pi_3o_pirate_camp', 'pi_3o_pt_sallivan_home', 'pi_3o_pt_sallivan_home_2_floor',
        'pi_3o_pt_sallivan_home_room', 'pi_3o_road_druid', 'pi_3o_road_first_leviathan_1', 'pi_3o_road_first_leviathan_2',
        'pi_3o_road_guarantad_stage_1', 'pi_3o_road_guarantad_stage_2', 'pi_3o_road_guarantad_stage_3',
        'pi_3o_road_guarantad_stage_4'];
}
